import React, { useCallback, memo } from "react";
import { useCart } from "../../context/CartContext";
import { Link } from "react-router-dom";

function CartItemsInCart({ item }) {
  const { updateQuantity, removeItem } = useCart();

  const {
    _id,
    thumbnail: image,
    slug,
    title,
    variantName,
    quantity,
    price,
    subtotal,
    mrp,
  } = item;

  const numPrice = Number(price);
  const numMrp = Number(mrp);

  const handleRemove = useCallback(() => {
    removeItem(_id);
  }, [removeItem, _id]);

  const handleQuantityChange = useCallback(
    (delta) => {
      const newQuantity = quantity + delta;
      if (newQuantity < 1) return;
      updateQuantity(_id, newQuantity);
    },
    [updateQuantity, _id, quantity],
  );

  return (
    <tr className="luxury-table-cart-row">
      {/* PRODUCT MAIN DETAILS CELL */}
      <td className="luxury-cart-cell-product">
        <div className="d-flex align-items-center">
          {/* 🌟 1. PORTRAIT COMPACT LAYOUT WRAPPER */}
          <div className="luxury-table-item-media-box me-3">
            <Link to={`/shop/${slug}`} className="d-block h-100">
              <img src={image} className="luxury-table-item-img" alt={title || "Product Image"} />
            </Link>
          </div>
          
          <div className="luxury-table-item-info">
            <Link to={`/shop/${slug}`} className="luxury-table-item-title-link">
              {title}
            </Link>
            {variantName && <div className="luxury-table-item-variant">{variantName}</div>}
            <button type="button" className="luxury-table-item-remove-btn mt-2" onClick={handleRemove}>
              Remove
            </button>
          </div>
        </div>
      </td>

      {/* MRP CELL */}
      <td className="luxury-cart-cell-mrp text-center d-none d-sm-table-cell">
        {!isNaN(numMrp) && numMrp > numPrice ? (
          <span className="luxury-table-old-mrp">
            ₹{numMrp.toFixed(0)}
          </span>
        ) : (
          <span className="luxury-table-old-mrp">-</span>
        )}
      </td>

      {/* SINGLE PRICE CELL */}
      <td className="luxury-cart-cell-price text-center">
        <span className="luxury-table-current-price">
          ₹{numPrice.toFixed(0)}
        </span>
      </td>

      {/* QUANTITY STEPPER CELL */}
      <td className="luxury-cart-cell-quantity text-center">
        <div className="luxury-table-qty-counter d-inline-flex align-items-center">
          <button 
            type="button" 
            className="table-qty-btn" 
            onClick={() => handleQuantityChange(-1)}
            disabled={quantity <= 1}
          >
        −
          </button>
          <span className="table-qty-value">{quantity}</span>
          <button 
            type="button" 
            className="table-qty-btn" 
            onClick={() => handleQuantityChange(1)}
          >
            +
          </button>
        </div>
      </td>

      {/* FINAL ROW SUB-TOTAL CELL */}
      <td className="luxury-cart-cell-total text-end">
        <span className="luxury-table-row-subtotal">
          ₹{Number(subtotal).toFixed(0)}
        </span>
      </td>
    </tr>
  );
}

export default memo(CartItemsInCart);